import { object, string } from "yup";

import { SelectOption } from "@covertree/ui";
import { PreciselyAddressWithUnit } from "@covertree/features";
import { preciselyAddress } from "@covertree/utils";

export interface ClaimsCheckForm {
  address: SelectOption<PreciselyAddressWithUnit>;
  lotUnit?: string | null;
}

export const claimsCheckValidation = object({
  address: preciselyAddress(),
  lotUnit: string().optional().nullable(),
});
